import type { TFunction } from "i18next";

const oauthDescriptionMaxLen = 280;

/** Map Better Auth / OAuth `error` query codes to in-app copy. */
export const oauthErrorUserMessage = (
  error: string | null,
  description: string | null,
  t: TFunction<"translation", undefined>
): string | null => {
  const code = error?.trim() ?? "";
  const hasCode = code.length > 0;
  const descRaw = description?.trim() ?? "";
  if (!hasCode && !descRaw) return null;

  switch (code) {
    case "account_already_linked_to_different_user":
      return t("login.oauth.accountAlreadyLinked");
    case "email_doesn't_match":
      return t("login.oauth.emailMismatch");
    case "unable_to_link_account":
      return t("login.oauth.unableToLink");
    case "state_mismatch":
    case "please_restart_the_process":
      return t("login.oauth.sessionExpired");
    case "invalid_callback_request":
      return t("login.oauth.invalidCallback");
    default:
      break;
  }

  if (descRaw) {
    return descRaw.length > oauthDescriptionMaxLen
      ? `${descRaw.slice(0, oauthDescriptionMaxLen)}…`
      : descRaw;
  }
  if (hasCode) {
    return t("login.oauth.genericWithCode", { code });
  }
  return null;
};
